import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  // apiKey: "AIzaSyB3p8FSAHPxJU2VAsaatUIwGr4O9xEgiXw",
  // authDomain: "nooyal.firebaseapp.com",
  // projectId: "nooyal",
  // storageBucket: "nooyal.appspot.com",
  // messagingSenderId: "992308603929",
  // appId: "1:992308603929:web:75584c7c47a990ab56ce88",
  // measurementId: "G-0ENJQGP5FH",
  apiKey: "AIzaSyA3BiEdj2AhxMm63agOK0r_qJyOqLRYzOw",
  authDomain: "heberease.firebaseapp.com",
  projectId: "heberease",
  storageBucket: "heberease.firebasestorage.app",
  messagingSenderId: "716971231242",
  appId: "1:716971231242:web:c798f38413138f6e3ef7f3",
  measurementId: "G-WNNV85HL1B"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export default app;
